import React, { useEffect, useState } from 'react'
import proimage from "../../Assets/images/pro-img.png";
import proimage2 from "../../Assets/images/pro-img-2.png";
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import { Link } from 'react-router-dom';
import { LanguageConstants } from '../../constants/LanguageConstants';
import { encodeID } from '../../utils/Helper';
import { useNavigate } from 'react-router-dom';

function ProductSuggestion(props :any) {
   const [data , setData] = useState([])
   const navigate = useNavigate()

   useEffect(()=>{
 if(props){
   setData(props?.data)
 }
   },[props])
   const navigatToProductdetailPage =(e:any)=>{
      return navigate(`/productdetail/${encodeID(e?.id)}`)
     } 

  return (
    <>
       <section className="pro-sugg-sec ">
            <div className="container">
               <div className="row">
                  <div className="col-8">
                     <h2 className="com-heading">{LanguageConstants?.CUSTOMER_PURCHASED}</h2>
                  </div>
                  <div className="col-4 text-end">
                     <Link to={'/product'} className="view-all-btn">{LanguageConstants?.VIEW_ALL}</Link>
                  </div>
               </div>
               <div className="row gy-4 gy-md-5">
                  {data?.length > 0 && data.map((res:any , i:any)=>(
                     <div className="col-6 col-md-3" onClick={()=>navigatToProductdetailPage(res)} key={i}>
                     <div className="pro-sugg-single">
                        <div className="pro-sugg-img">   
                           <img src={res?.product_image_details?.file_path} alt="product"/>
                        </div>
                        <div className="pro-sugg-ct">
                           <h3 className="pro-sugg-ttl">{res?.product_details?.name}</h3>
                           <p className="pro-sugg-para">{res?.product_details?.description} <span className="more-view">more...</span></p>
                           </div>
                     </div>
                  </div>
                  )) }
               </div>
            </div>
          </section>
    </>
  )
}

export default ProductSuggestion